/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const HelpCircleIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="HelpCircleIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M7.5 4C6.67157 4 6 4.67157 6 5.5V6H7V5.5C7 5.22386 7.22386 5 7.5 5H9.32578C9.75296 5 9.98341 5.50106 9.70541 5.8254L8.36111 7.39374C8.12809 7.6656 8 8.01186 8 8.36992V9H9V8.36992C9 8.25057 9.0427 8.13515 9.12037 8.04453L10.4647 6.47619C11.2987 5.50318 10.6073 4 9.32578 4H7.5Z"
                fill="currentColor"
              />
              <path
                d="M8.5 11.25C8.91421 11.25 9.25 10.9142 9.25 10.5C9.25 10.0858 8.91421 9.75 8.5 9.75C8.08579 9.75 7.75 10.0858 7.75 10.5C7.75 10.9142 8.08579 11.25 8.5 11.25Z"
                fill="currentColor"
              />
            </g>
            <path
              opacity="0.4"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.5 1C12.0899 1 15 3.91015 15 7.5C15 11.0899 12.0899 14 8.5 14C4.91015 14 2 11.0899 2 7.5C2 3.91015 4.91015 1 8.5 1ZM8.5 2C5.46243 2 3 4.46243 3 7.5C3 10.5376 5.46243 13 8.5 13C11.5376 13 14 10.5376 14 7.5C14 4.46243 11.5376 2 8.5 2Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

HelpCircleIcon.tags = [
  'question',
  'support',
  'help',
  'faq',
  'assistance',
  'information',
  'inquiry',
];

HelpCircleIcon.category = 'General Icons';

HelpCircleIcon.iconSize = 16;
